var _path, _rect, _rect2, _rect3, _polygon, _rect4, _polygon2, _polygon3, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,118.125c-76.156,0-137.875,61.719-137.875,137.875S179.844,393.875,256,393.875 S393.875,332.156,393.875,256S332.156,118.125,256,118.125z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 235.906,
    width: 40.156,
    height: 77.297
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 235.906,
    y: 434.703,
    width: 40.156,
    height: 77.297
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.657,
    y: 82.229,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 102.3047 -42.376)",
    width: 77.296,
    height: 40.15
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "368.156,396.547 422.828,451.219 451.219,422.813 396.563,368.156  "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 235.906,
    width: 77.281,
    height: 40.156
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "434.688,235.922 434.688,276.078 512,276.063 512,235.906  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "60.781,422.813 89.156,451.219 143.813,396.547 115.438,368.156  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "451.219,89.156 422.813,60.781 368.156,115.438 396.563,143.844  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.bb6384112f2e1e6d9bb0e219e5a7b0de.svg";
export { ForwardRef as ReactComponent };